export const isChrome = navigator.userAgent.indexOf("Chrome") !== -1;
export const isFirefox = navigator.userAgent.indexOf("Firefox") !== -1;

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) return parts.pop().split(";").shift();
}
